import { render, staticRenderFns } from "./VideoClipSvg.vue?vue&type=template&id=595d4b76&"
import script from "./VideoClipSvg.vue?vue&type=script&lang=ts&"
export * from "./VideoClipSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports